function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "05949B17-2EB2-4199-9F2C-C546497E0616");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M255.836,1.805 L255.836,3.116 L256.96,3.116 C257.201,3.116 257.386,3.091 257.521,3.041 L257.521,3.041 C257.656,2.992 257.759,2.913 257.828,2.803 L257.828,2.803 C257.897,2.694 257.932,2.576 257.932,2.449 L257.932,2.449 C257.932,2.261 257.865,2.106 257.73,1.985 L257.73,1.985 C257.595,1.865 257.381,1.805 257.088,1.805 L257.088,1.805 L255.836,1.805 Z M253.459,3.349 C253.459,5.193 254.989,6.697 256.864,6.697 L256.864,6.697 C258.738,6.697 260.267,5.193 260.267,3.349 L260.267,3.349 C260.267,1.504 258.738,6.03961325e-14 256.864,6.03961325e-14 L256.864,6.03961325e-14 C254.989,6.03961325e-14 253.459,1.504 253.459,3.349 L253.459,3.349 Z M255.312,1.369 L257.066,1.369 C257.418,1.369 257.688,1.404 257.871,1.475 L257.871,1.475 C258.055,1.546 258.201,1.671 258.31,1.851 L258.31,1.851 C258.42,2.031 258.474,2.23 258.474,2.448 L258.474,2.448 C258.474,2.729 258.383,2.965 258.202,3.158 L258.202,3.158 C258.021,3.35 257.74,3.472 257.36,3.525 L257.36,3.525 C257.5,3.592 257.604,3.658 257.677,3.722 L257.677,3.722 C257.829,3.863 257.975,4.038 258.11,4.25 L258.11,4.25 L258.795,5.329 L258.14,5.329 L257.616,4.504 C257.464,4.266 257.338,4.084 257.239,3.958 L257.239,3.958 C257.139,3.831 257.051,3.744 256.973,3.693 L256.973,3.693 C256.896,3.643 256.815,3.608 256.734,3.587 L256.734,3.587 C256.674,3.576 256.579,3.569 256.443,3.569 L256.443,3.569 L255.836,3.569 L255.836,5.329 L255.312,5.329 L255.312,1.369 Z",
  id: "path-1"
}), React.createElement("path", {
  d: "M4.26325641e-14,1.868 L4.26325641e-14,24.255 L5.851,24.255 L5.969,15.509 L16.992,15.493 C19.371,15.493 21.449,14.864 23.162,13.628 L23.162,13.628 C25.019,12.298 25.958,10.634 25.958,8.68 L25.958,8.68 C25.958,6.727 25.019,5.063 23.166,3.738 L23.166,3.738 C21.448,2.496 19.371,1.868 16.992,1.868 L16.992,1.868 L4.26325641e-14,1.868 Z M5.851,6.765 L16.992,6.765 C17.92,6.765 18.683,6.99 19.323,7.454 L19.323,7.454 C20.01,7.95 20.089,8.391 20.089,8.68 L20.089,8.68 C20.089,8.969 20.01,9.411 19.323,9.908 L19.323,9.908 C18.683,10.37 17.92,10.596 16.992,10.596 L16.992,10.596 L5.851,10.596 L5.851,6.765 Z",
  id: "path-3"
}), React.createElement("path", {
  d: "M56.053,1.922 L56.053,24.219 L61.903,24.219 L61.903,15.516 L70.255,15.516 L76.298,24.219 L83.123,24.219 L76.656,14.948 C77.868,14.552 78.93,13.955 79.824,13.168 L79.824,13.168 C81.276,11.906 82.011,10.409 82.011,8.719 L82.011,8.719 C82.011,6.77 81.071,5.111 79.217,3.785 L79.217,3.785 C77.499,2.549 75.422,1.922 73.044,1.922 L73.044,1.922 L56.053,1.922 Z M61.903,5.447 L73.044,5.447 C73.965,5.447 74.715,5.685 75.341,6.179 L75.341,6.179 C76.06,6.737 76.143,7.257 76.143,7.598 L76.143,7.598 C76.143,7.94 76.06,8.459 75.335,9.021 L75.335,9.021 C74.715,9.51 73.965,9.749 73.044,9.749 L73.044,9.749 L61.903,9.749 L61.903,5.447 Z",
  id: "path-5"
}), React.createElement("path", {
  d: "M174.071,1.867 L174.071,24.219 L179.92,24.219 L179.92,15.492 L188.272,15.492 L194.314,24.219 L201.136,24.219 L194.67,14.923 C195.884,14.526 196.947,13.927 197.844,13.137 L197.844,13.137 C199.294,11.873 200.029,10.373 200.029,8.679 L200.029,8.679 C200.029,6.727 199.089,5.064 197.234,3.736 L197.234,3.736 C195.517,2.495 193.44,1.867 191.062,1.867 L191.062,1.867 L174.071,1.867 Z M179.92,6.765 L191.062,6.765 C191.998,6.765 192.76,6.988 193.393,7.454 L193.393,7.454 C194.081,7.95 194.161,8.391 194.161,8.679 L194.161,8.679 C194.161,8.968 194.081,9.41 193.386,9.911 L193.386,9.911 C192.76,10.37 191.998,10.594 191.062,10.594 L191.062,10.594 L179.92,10.594 L179.92,6.765 Z",
  id: "path-7"
}), React.createElement("path", {
  d: "M209.695,1.868 C205.222,1.868 201.977,4.749 201.977,8.719 L201.977,8.719 L201.977,16.691 C201.977,20.822 205.455,24.183 209.732,24.183 L209.732,24.183 L224.991,24.183 C229.268,24.183 232.747,20.822 232.747,16.691 L232.747,16.691 L232.747,8.719 C232.747,4.749 229.475,1.868 224.968,1.868 L224.968,1.868 L209.695,1.868 Z M208.642,16.691 L208.642,8.719 C208.642,8.076 209.152,7.511 209.732,7.511 L209.732,7.511 L224.991,7.511 C225.571,7.511 226.08,8.076 226.08,8.719 L226.08,8.719 L226.08,16.691 C226.08,17.336 225.571,17.9 224.991,17.9 L224.991,17.9 L209.732,17.9 C209.152,17.9 208.642,17.336 208.642,16.691 L208.642,16.691 Z",
  id: "path-9"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Permatrol",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Pagina_principal",
  transform: "translate(-59.000000, -79.000000)"
}, React.createElement("g", {
  id: "PRIMERA"
}, React.createElement("g", {
  id: "perma_logo_new",
  transform: "translate(59.000000, 79.000000)"
}, React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-1"
})), React.createElement("use", {
  id: "Clip-2",
  fill: "#061F79",
  xlinkHref: "#path-1"
}), React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-3"
})), React.createElement("use", {
  id: "Clip-8",
  fill: "#061F79",
  xlinkHref: "#path-3"
}), React.createElement("polygon", {
  id: "Fill-10",
  fill: "#061F79",
  points: "28.2443 2.086 28.2443 24.219 51.9123 24.219 51.9123 19.347 34.0933 19.347 34.0933 15.588 51.9123 15.588 51.9123 10.717 34.0933 10.717 34.0933 6.956 51.9123 6.956 51.9123 2.086"
}), React.createElement("mask", {
  id: "mask-6",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-5"
})), React.createElement("use", {
  id: "Clip-12",
  fill: "#061F79",
  xlinkHref: "#path-5"
}), React.createElement("polygon", {
  id: "Fill-14",
  fill: "#061F79",
  points: "144.4262 1.8673 144.4262 6.7653 154.6442 6.7653 154.6442 24.2193 160.4942 24.2193 160.4942 6.7653 170.7112 6.7653 170.7112 1.8673"
}), React.createElement("mask", {
  id: "mask-8",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-7"
})), React.createElement("use", {
  id: "Clip-16",
  fill: "#061F79",
  xlinkHref: "#path-7"
}), React.createElement("polygon", {
  id: "Fill-18",
  fill: "#061F79",
  points: "235.4522 1.9033 235.4522 24.2183 260.3192 24.2183 260.3192 19.3243 241.4942 19.3243 241.4942 1.9033"
}), React.createElement("mask", {
  id: "mask-10",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-9"
})), React.createElement("use", {
  id: "Clip-20",
  fill: "#061F79",
  xlinkHref: "#path-9"
}), React.createElement("polygon", {
  id: "Fill-23",
  fill: "#EE3746",
  points: "130.7192 1.9888 117.1322 24.2428 124.3572 24.2428 132.9742 9.3738 142.6962 24.2428 149.2952 24.2428 135.7742 1.9888"
}), React.createElement("polygon", {
  id: "Fill-24",
  fill: "#061F79",
  points: "87.5957 24.2431 92.7307 24.2431 92.8837 14.6661 98.6387 24.2431 102.8407 24.2431 108.4357 14.8391 108.3577 24.2431 113.5667 24.2431 113.5667 2.0341 108.4357 2.0341 100.6407 16.5341 93.0387 2.0341 87.5967 1.9891"
}), React.createElement("path", {
  d: "M133.158,48.7512 L133.156,48.7512 C128.447,48.7422 124.603,44.9252 124.601,40.1672 C124.607,37.1062 126.388,34.6802 128.261,32.3332 C129.521,30.7572 130.771,29.3972 131.693,27.7372 C132.636,26.1132 133.179,23.9292 133.179,23.9292 C133.179,23.9292 133.754,26.2252 134.692,27.7972 C135.604,29.3592 136.845,30.8312 138.043,32.3262 C139.914,34.6712 141.697,37.1042 141.702,40.1692 C141.7,44.9252 137.867,48.7422 133.158,48.7512 M140.175,28.7742 C138.471,26.6472 136.704,24.5532 135.407,22.3282 C134.072,20.0912 133.254,16.8232 133.254,16.8232 C133.254,16.8232 132.564,19.6622 131.224,21.9712 C129.912,24.3342 128.046,26.5432 126.252,28.7842 C123.589,32.1252 121.052,35.5792 121.043,39.9352 C121.047,46.7092 126.515,52.1422 133.22,52.1532 C139.924,52.1422 145.38,46.7092 145.385,39.9382 C145.375,35.5752 142.837,32.1152 140.175,28.7742",
  id: "Fill-25",
  fill: "#061F79"
}), React.createElement("path", {
  d: "M131.8298,34.2371 C131.6428,34.5221 131.3548,34.6541 131.1808,34.5281 C131.0078,34.4031 131.0188,34.0701 131.2048,33.7851 C131.3888,33.5001 131.6788,33.3681 131.8528,33.4941 C132.0248,33.6181 132.0168,33.9511 131.8298,34.2371 L131.8298,34.2371 Z M130.9288,36.6711 C130.6568,37.1811 130.1858,37.4451 129.8768,37.2651 C129.5688,37.0781 129.5388,36.5161 129.8118,36.0081 C130.0838,35.4961 130.5558,35.2301 130.8628,35.4151 C131.1738,35.6001 131.2028,36.1611 130.9288,36.6711 L130.9288,36.6711 Z M133.1508,28.9041 C132.1008,33.1921 126.9208,35.9711 126.9208,40.3441 C126.9208,43.7761 129.7128,46.5591 133.1548,46.5591 C136.5988,46.5591 139.3818,43.7761 139.3818,40.3451 C139.3818,35.9661 134.1978,33.1811 133.1518,28.9041 L133.1508,28.9041 Z",
  id: "Fill-28",
  fill: "#EE3746"
})))));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "261px",
    height: "53px",
    viewBox: "0 0 261 53",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.1d848cb0.svg";
export { ForwardRef as ReactComponent };